import { render, staticRenderFns } from "./NotarisAdd.vue?vue&type=template&id=341da8b6&"
import script from "./NotarisAdd.vue?vue&type=script&lang=js&"
export * from "./NotarisAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports